import { useEffect } from 'react'

import { useUserProfile } from '../../hooks/useUserProfile'

import { useUsersAnalytics } from '@/shared/lib/analytics'
import { CardBody } from '@/shared/ui/Card'
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalTitle,
  ModalFooter,
  ModalDescription
} from '@/shared/ui/Modal'

import { UserProfileBody } from './Body'
import { UserProfileFooterActions } from './FooterActions'



interface UserModalProps {
  userUid: string
}

export const UserModal = ({ userUid }: UserModalProps) => {
  const { userProfile, refetchUserProfile } = useUserProfile({ userUid })

  const { trackUserProfileViewed } = useUsersAnalytics()

  useEffect(() => {
    if (userProfile) {
      trackUserProfileViewed(userProfile)
    }
  }, [userProfile, trackUserProfileViewed])

  const displayName = userProfile?.name ?? 'Carregando...'

  return (
    <Modal className="sm:max-w-lg" asCard>
      <ModalHeader>
        <ModalTitle>Perfil de Usuário</ModalTitle>
      </ModalHeader>
      <ModalDescription className="hidden">
        Detalhamento do perfil de {displayName}
      </ModalDescription>
      {!userProfile && (
        <ModalBody>
          <CardBody className="flex flex-col items-center justify-center py-8">
            <p className="text-lg font-semibold text-gray-700">{displayName}</p>
            <p className="text-sm text-gray-500 mt-1">Carregando perfil...</p>
          </CardBody>
        </ModalBody>
      )}
      {userProfile && (
        <ModalBody>
          <UserProfileBody userProfile={userProfile} itsMe={false} />
        </ModalBody>
      )}
      <ModalFooter>
        <UserProfileFooterActions
          itsMe={false}
          onEditProfile={() => {}}
          onSignOut={() => {}}
          userUid={userUid}
        />
      </ModalFooter>
    </Modal>
  )
}
